import { Portal } from '@radix-ui/react-popover';
import { type PopoverContentProps } from '@radix-ui/react-popover';
import React from 'react';

import { PopoverContentCard } from './styled';

type Props = PopoverContentProps & {
  /**
   * decides if the popover content card should be placed in portal or not
   * @default true
   */
  placeInPortal?: boolean;
};

const PopoverContent = React.forwardRef<HTMLDivElement, Props>(
  ({ children, placeInPortal = true, ...rest }, forwardedRef) => {
    const card = (
      <PopoverContentCard
        collisionPadding={12}
        sideOffset={12}
        {...rest}
        ref={forwardedRef}>
        {children}
      </PopoverContentCard>
    );

    return placeInPortal ? <Portal>{card}</Portal> : card;
  },
);

PopoverContent.displayName = 'PopoverContent';

export default PopoverContent;
